
export enum Breakpoints {
  xs = 576,
  sm = 768,
  md = 992,
  lg = 1200,
  xl = Infinity,
}

export const detectScreenSize = (wnd: Window = window) => {
  const { xs, sm, md, lg } = Breakpoints;
  const { innerWidth } = wnd;
  return {
    exact: {
      xs: innerWidth <= xs,
      sm: innerWidth > xs && innerWidth <= sm,
      md: innerWidth > sm && innerWidth <= md,
      lg: innerWidth > md && innerWidth <= lg,
      xl: innerWidth > lg,
    },
    exactOrBiggerThan: {
      xs: innerWidth > 0,
      sm: innerWidth > xs,
      md: innerWidth > sm,
      lg: innerWidth > md,
      xl: innerWidth > lg,
    },
    exactOrLowerThan: {
      xs: innerWidth <= xs,
      sm: innerWidth <= sm,
      md: innerWidth <= md,
      lg: innerWidth <= lg,
      xl: innerWidth <= Infinity,
    }
  };
};
